import React from "react";

// COMPONENTS
import Button from "@components/Button/Button";
import FeatherIcon from "@components/FeatherIcon/FeatherIcon";
import StackLayout from "@components/layouts/StackLayout/StackLayout";

// HELPERS
import {connectRedux, createClassName, handleRouteHidden} from "@helpers/utils";

// REDUCERS
import {actions as appActions} from "@reducers/app";
import Partner from "../../classes/Partner";
import Session from "../../classes/Session";


export default connectRedux(state => ({
	app: state.app
}), {
	setAppState: appActions.setState
}, class StatusRoute extends React.PureComponent
{
	state = _getInitialState.call(this);

	async componentDidMount()
	{
		await handleRouteHidden(this, true);
		const {props} = this;
		const {actions, location, match} = props;
		const {state: locationState = {}} = location;
		const newStateProps = {};

		if (location.pathname.indexOf("/error") >= 0)
		{
			newStateProps.status = "error";
			document.title = locationState.error && locationState.error.message === "PARTNER_NOT_FOUND" ? "Sidan kunde inte hittas" : "Ett fel uppstod";
		}
		else if (location.pathname.indexOf("/success") >= 0)
		{
			newStateProps.status = "success";
		}

		const newAppStateProps = {};
		const session = newAppStateProps.session = new Session();
		const partner = newAppStateProps.partner = new Partner(match.params.partnerName);
		await partner.loadData(session.authToken);
		await actions.setAppState(newAppStateProps);

		if (Object.keys(newStateProps).length > 0)
		{
			this.setState(newStateProps);
		}
	}

	componentWillUnmount()
	{
		handleRouteHidden(this, false);
	}

	render()
	{
		const {props, state} = this;
		if (!state.status)
		{
			return null;
		}

		const {location} = props;
		const {state: locationState = {}} = location;
		const classes = createClassName("StatusRoute", {
			"App-route": true,
			"hidden": state.hidden,
			"success": state.status === "success",
			"error": state.status === "error"
		});

		function ShowStatusText(partner)
		{

			if (partner.partner === "fair-futur")
			{
				return (
					<React.Fragment>
						<p style={{maxWidth: "600px", textAlign: "center"}}>
							Din kapitalförsäkringsdepå är nu nästan klar. Det som återstår (om detta inte redan är
							gjort) är att signera depåavtalet i vår signeringsportal hos Futur.
						</p>
						<p style={{maxWidth: "600px", textAlign: "center"}}>
							Vänligen klicka på länken nedan för att komma dit. Logga in som privatperson.
						</p>
					</React.Fragment>
				);
			}

			if (partner.partner === "fair-kyc")
			{
				return (
					<React.Fragment>
						<p style={{maxWidth: "600px", textAlign: "center"}}>
							Tack! Din kundkännedomsinformation har nu uppdateras.
						</p>
						<p style={{maxWidth: "600px", textAlign: "center"}}>
							Klicka på knappen nedan för att komma tillbaka till kundportalen.
						</p>
					</React.Fragment>
				);
			}

			return (
				<p>Avtalet har skapats och allt är klart!</p>
			);
		}

		let buttonText = "Avsluta";
		if (this.props.app.partner.name === "fair-futur")
		{
			buttonText = "Till signeringsportalen";
		}
		else if (this.props.app.partner.name === "fair-kyc")
		{
			buttonText = "Till kundportalen";
		}

		return (
			<div className={classes}>
				<StackLayout orientation="vertical" fullWidth>

					{state.status === "success" && (
						<React.Fragment>
							<FeatherIcon className="Status-icon" type="check-circle" size={100} />
							<h1>Färdigt</h1>

							<ShowStatusText partner={this.props.app.partner.name} />

							<Button className="Status-button"
											label={buttonText}
											appearance="primary"
											onClick={this._handleFinishClick} />
						</React.Fragment>
					)}

					{state.status !== "success" && (
						<React.Fragment>
							<FeatherIcon className="Status-icon" type="alert-circle" size={100} />
							<h1>Ett fel uppstod</h1>

							{locationState.error ? (
								<p>{_getErrorMessage(locationState.error.message)}</p>
							) : (
								<React.Fragment>
									<p>{_getErrorMessage()}</p>
								</React.Fragment>
							)}
						</React.Fragment>
					)}
				</StackLayout>
			</div>
		);
	}

	// Internal methods
	_handleFinishClick = () =>
	{
		if (this.props.app.partner.name === "fair-kyc")
		{
			window.location = "https://kundportal.fairinvestments.se";
		}
		else
		{
			window.location = this.props.app.partner.redirectUrl;
		}
	};
});


// PRIVATE FUNCTIONS
function _getInitialState()
{
	return {
		hidden: true,
		busy: false,
		status: null,
		caseId: null
	};
}

function _getErrorMessage(errorMessage)
{
	switch (errorMessage)
	{
		case "PARTNER_UNDEFINED":
			return "Ingen partner angiven.";
		case "AUTH_TOKEN_REQUIRED":
			return "Åtkomst ej tillåten.";
		case "UNKOWN_ERROR":
			return "Ett okänt fel har inträffat.";
		case "INVALID_IDENTITY":
			return "Person- eller organisationsnumret är inte giltigt.";
		default:
			return "Sidan kunde inte hittas.";
	}
}


// WEBPACK FOOTER //
// ./src/routes/Status/Status.js